import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';
import { ConditionalWrapper } from '@cian/conditional-component';
import { widgetContext } from '../../../context/widgetContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Базовая обертка для элементов в строке фильтров для десктопа
 * Решает задачи:
 *   * скругления у первого (левый край) и у последнего (правый край) фильтров
 *   * граница-разделитель между фильтрами
 * */
export var FilterWrapper = function FilterWrapper(props) {
  var isLastFilter = props.isLastFilter,
      isFirstFilter = props.isFirstFilter,
      children = props.children;

  var _React$useContext = React.useContext(widgetContext),
      isDesktop = _React$useContext.isDesktop;

  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    if: isDesktop,
    thenRender: function thenRender(el) {
      var _cn;

      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [' ', /*#__PURE__*/_jsx("div", {
          className: cn(styles['container'], (_cn = {}, _defineProperty(_cn, styles['last'], isLastFilter), _defineProperty(_cn, styles['first'], isFirstFilter), _cn)),
          children: el
        })]
      });
    },
    children: children
  });
};